module.exports = __webpack_public_path__ + "img/cd09abe1-1092-4b50-bc50-e986dd46af7e 1.d9cfd6c5.png";